import React, { useEffect, useRef } from 'react'
import { useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import HomeVideo from '../../assets/images/check-video.mp4';

export default function ApiPenetration() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <section className="inner-banner" style={{ position: 'relative', overflow: 'hidden' }}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                    }}
                >
                    <source src={HomeVideo} type="video/mp4" />
                </video>
                <h1 className='heading'>Access Control & Authorization Review</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link to="#">Home</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item active" aria-current="page">Access Control</li>
                    </ol>
                </nav>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='header-title mb-40px'>
                                <h3 className='heading wow fadeInUp' >What Is Access Control in Security?</h3>
                                <p className='paragraph'>
                                    Access control is a fundamental element of IT and cybersecurity, governing who can view or utilize specific resources in a computing environment. Its primary goal is to minimize security risks by ensuring that only authorized
                                    users, systems, or services have access. This comprehensive process includes identifying individuals or systems,
                                    authenticating their identities, authorizing access, and auditing usage patterns. By implementing effective access control measures, organizations can protect sensitive information and mitigate the risk of unauthorized access.
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='service-left-image' style={{ backgroundColor: '#ffff', borderRadius: '50px' }}>
                                <img src={require('../../assets/images/services/access-control.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                    <div className="row top">
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/depth-perception.webp')} alt="anytime" />
                                <h2>Depth</h2>
                                <p>Our hackers go in depth to find vulnerabilities in your system.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/service.webp')} alt="Mobile Application Development" />
                                <h2>Standards</h2>
                                <p>We use industry standard tools to find even the bad loopholes.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/receipt.webp')} alt="Mobile App Development Services " />
                                <h2>Report</h2>
                                <p>Get a penetration testing report that's written in layman language.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/comment.webp')} alt="Mobile App Development Services " />
                                <h2>Good News</h2>
                                <p>Yes, your free consultation is just a click away.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom' style={{ background: '#101218' }}>
                <div className='container'>
                    <div className='header-title text-center'>
                        <h2 className='heading wow fadeInUp'>How Does Access Control Work? 5 Key Components</h2>
                        <p>Here is the general process for securing access and managing access control within an organization:</p>
                    </div>
                    <div className='row'>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Authentication</h2>
                                <p className='paragraph wow fadeInUp'>Authentication is the initial step in access control, involving the verification of the identity of a user or system requesting access. This process typically matches the provided credentials against stored information. Common authentication methods include password-based, biometric, and certificate-based approaches.</p><br />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Authorization</h2>
                                <p className='paragraph wow fadeInUp'>Authorization occurs after successful authentication, determining access based on assigned privileges. These predefined privileges dictate which resources can be accessed and to what extent. By adhering to the principle of least privilege, authorization ensures that users and systems receive only the access necessary for their specific roles within the organization.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Access</h2>
                                <p className='paragraph wow fadeInUp'>Access refers to the actual use or interaction with a resource, which can include viewing, modifying, or deleting data, as well as utilizing a service. The level of access granted is determined by the authorization process. Monitoring and controlling access is essential to prevent unauthorized activities and ensure data security.</p><br />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Manage</h2>
                                <p className='paragraph wow fadeInUp'>Managing access control involves maintaining and updating the access control system. This includes defining and revising access policies, managing user credentials, onboarding and offboarding users, and maintaining access control hardware and software. Effective management ensures that the access control system remains robust, secure, and up-to-date.</p><br />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Audit</h2>
                                <p className='paragraph wow fadeInUp'>Auditing is a critical component of access control, involving the monitoring and recording of access patterns and activities. It helps identify unusual or suspicious behavior and supports forensic investigations. Regular audits can uncover security vulnerabilities and provide insights for improving the access control system, enhancing overall security measures.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="software-develop-cyber appbenefits">
                                <h2>Review and Maintenance</h2>
                                <p className='paragraph wow fadeInUp'>Regularly reviewing access permissions and updating policies is essential for adapting to organizational changes and mitigating security vulnerabilities. This proactive strategy reduces the risk of unauthorized access, aligns with current business needs, promotes regulatory compliance, and fosters a culture of security awareness among employees.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='more-services mb-0' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='header-title mb-40px top'>
                                <h3 className='heading wow fadeInUp' >Access Control as a Service</h3>
                                <p className='paragraph'>We have collaborated with a variety of industries, including Airlines, Supply chains, Fintech, Health-tech, e-commerce, etc. We believe that a pentest will have the greatest impact on a company when the pentesting team has a thorough understanding of the web application’s API business logic. Therefore, we dedicate a specialized team to comprehending the business logic of the issue at hand.</p>
                            </div>
                        </div>
                        <div className='col-lg-6 mb-40px top service-more-detials'>
                            <div className="cards">
                                <div className='box-text'>
                                    <h4 className='heading'>Explore More Services</h4>
                                    <p className='paragraph'>"Discover comprehensive cybersecurity solutions to safeguard your digital assets today."</p>
                                    <div className='services-button'>
                                        <Link to="/services">
                                            <button className='btn footer-btn btn-class'>More Services<span>More Services</span></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </section>

            <section className='faq-section-b bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <h2 className='heading text-center text-dark' style={{ fontWeight: 'bold' }}>Frequently Asked Questions</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='service-detail-left-side'>
                                <div className='faq-section-inner'>
                                    <div class="accordion wow fadeInUp" id="accordionExample">
                                        <div className='faq-box'>

                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        How does consumer marketing differ from other forms of marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Consumer marketing focuses specifically on understanding and targeting individual consumers, whereas other forms of marketing may target businesses or broader market segments.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        What strategies does Brand Street use to engage consumers?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We utilize a variety of strategies including targeted messaging, personalized experiences, influencer partnerships, and interactive content to engage consumers and drive brand affinity.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        How does Brand Street ensure that its consumer marketing campaigns resonate with target audiences?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We conduct thorough audience research and employ data-driven insights to tailor our campaigns to the unique preferences and behaviors of our target audience.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        Can Brand Street help with both B2C and B2B consumer marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Yes, we have experience working with clients in both B2C and B2B industries, developing customized strategies to effectively reach and engage their respective target audiences.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        What types of consumer marketing channels does Brand Street utilize?
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We leverage a mix of traditional and digital channels including social media, email marketing, content marketing, experiential activations, and influencer partnerships to reach and engage consumers across multiple touchpoints.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
